<script setup>
  import UpgradeBlock from '@/components/UpgradeBlock.vue';
  
  const props = defineProps({
    upgrade: {
      type: Array,
      required: true
    }
  })
</script>

<template>
  <UpgradeBlock
    :upgrade="props.upgrade"
    buttonPosition="stacked"
  >
    <p class="jwx-upgrade-block__text">Upgrade to unlock <strong>Premium</strong> and <strong>Pro</strong> Models.</p>
    <p class="jwx-upgrade-block__text" data-size="small"><strong>Plus</strong> members will have access to all <strong>Premium</strong> models. Upgrading to <strong>Pro</strong> or <strong>Gold</strong> will unlock all <strong>Premium</strong> and <strong>Pro</strong> models.</p>
  </UpgradeBlock>
</template>